import { FC, useMemo } from 'react'
import { ButtonTransformer } from 'src/relay/Transformers/ButtonTransormer'
import {
  ImageTransformer,
  unwrapMedia,
} from 'src/relay/Transformers/ImageTransformer'
import PerspectivePush, {
  PerspectivePushProps,
} from 'src/components/PerspectivePush'
import { useTranslation } from 'react-i18next'
import { getThemeColor } from 'src/relay/Transformers/ThemeTransformer'

import { BlockProps } from '../props'

import { ExpandableImageTextBlockProps } from './props'

const ExpandableImageTextBlock: FC<
  BlockProps<ExpandableImageTextBlockProps>
> = ({ data }) => {
  const { t } = useTranslation()
  const props: PerspectivePushProps = useMemo(
    () => ({
      ...(data.title && {
        blockTitleProps: {
          ...(data.sectionTitle && {
            tag: data.sectionTitle,
            color: getThemeColor(data?.theme?.data),
          }),
          title: data.title,
          actionButtonProps: ButtonTransformer({ data: data.cta }),
        },
      }),
      perspectives: data?.expandableContent?.map((slide) => ({
        color: getThemeColor(data?.theme?.data),
        title: slide.title || '',
        ...(slide.text && {
          richTextProps: { html: slide.text },
        }),
        pictureProps: {
          imageProps: ImageTransformer(unwrapMedia(slide.desktopImage)),
          mobileImageProps: ImageTransformer(unwrapMedia(slide.mobileImage)),
        },
        ...(slide.ctaUrl && {
          actionButtonProps: ButtonTransformer({
            data: {
              label: slide.ctaTitle,
              target: slide.ctaTarget,
              url: slide.ctaUrl,
            },
            theme: data.theme?.data,
          }),
        }),
      })),
      sliderProps: {
        texts: {
          dot: t('slider.dot'),
          next: t('slider.next'),
          previous: t('slider.previous'),
        },
      },
    }),
    [data, t]
  )

  return <PerspectivePush {...props} />
}

export default ExpandableImageTextBlock
